import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';
// import { Constants } from 'src/app/constants';
// import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false // NOSONAR
})
export class ToolbarComponent implements OnInit {

  @ViewChild('home') private home: RouterLinkActive; // NOSONAR
  enableHomeGrey = false;
  enableHomeRed = true;
  activeBoard: boolean = false;
  highlightDashboard = false;
  highlightHistory = false;
  highlightImport = false;
  highlightReports = false;
  highlightSafetydash = false;
  highlightCPM = false;
  highlightKPI = false;
  isAccessible = false;
  highlightNotification = false;
  constructor(private readonly router: Router) { } //private state: ExportStateService, private  readonly constants: Constants) { }

  ngOnInit(): void { // NOSONAR
    // do nothing
  }
  ngAfterContentChecked(): void { // NOSONAR
    this.makeAllFalse();
    if (this.router.url == "/" || this.router.url == '/dashboard') { // NOSONAR
      this.highlightDashboard = true;
    }
    // else if (this.router.url == '/history') {
    else if (this.router.url.includes('history') && !this.router.url.includes('reports') && !this.router.url.includes('dashboard/event-history')) {
      this.highlightHistory = true;
    }
    else if (this.router.url == '/import') { // NOSONAR
      this.highlightImport = true;
    }
    // else if (this.router.url == '/reports-dashboard'){
    else if (this.router.url.includes('reports')) {
      this.highlightReports = true;
    }
    else if (this.router.url == '/cpMatrix') { // NOSONAR
      this.highlightCPM = true;
    }
    else if (this.router.url == '/kpi') { // NOSONAR
      this.highlightKPI = true;
    }
    else if (this.router.url.includes('safety-dashboard')) {
      this.highlightSafetydash = true;
    }
    else if (this.router.url.includes('/notification')) {
      this.highlightNotification = true;
    }
  }

  makeAllFalse() {
    this.activeBoard = false;
    this.highlightDashboard = false;
    this.highlightHistory = false;
    this.highlightImport = false;
    this.highlightReports = false;
    this.highlightSafetydash = false;
    this.highlightCPM = false;
    this.highlightKPI=false;
    this.highlightNotification=false;
  }

}
